<template>
	<div class="engine-city-search">
		<div class="row">
			<div class="col" style="display: flex; flex-direcion: row;">
				<input class="form-control" v-model="citySearchPhrase" placeholder="Město" v-on:keyup.enter="fetchCityNames"/>
				<div class="city-input-hide ml-1" @click="hideCity"> {{ cityHide ? '▼' : '◄' }} </div>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col">
				<button class="btn" style="width: 100%; background-color: #cccccc;" @click="fetchCityNames"> Hledat </button>
			</div>
		</div>
		<div class="row mt-2">
			<div class="col text-left">
				<span class="selected-city"> Vybráno: {{ selectedCity }} </span>
			</div>
		</div>

		<div class="row" v-show="cityHide" v-if="! searching">
			<div class="col text-left">
				<ul class="list-group my-list">
					<li class="list-group-item cursor-pointer text-left"
						:class="{ active: isActive(name.city_name) }"
						v-for="name of cityNames" :key="name.city_name"
						@click="citySelect(name.city_name)"
						> {{ name.city_name }}  </li>
				</ul>
			</div>
		</div>

		<div v-else v-show="cityHide" class="city-list-searching">
			<circle-spin :loading="searching"></circle-spin>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'

export default {
    name: 'citySearch',

	data () {
		return {
			citySearchPhrase: '',
			searching: false,
			selectedCity: null,
			cityNames: [],
			cityHide: true,
		}
	},

	methods: {
		hideCity () {
			this.cityHide = ! this.cityHide
		},

		async fetchCityNames () {
			if (this.citySearchPhrase.split('').length < 2) {
				return
			}

			const citySearchPhrase = this.citySearchPhrase
			this.searching = true

			const hold = await AdditionsService.fetchCityNames(citySearchPhrase)

			this.cityNames = hold.data
			this.searching = false
		},

		citySelect (s) {
			this.selectedCity = s
			this.$emit('citySelected', s)
		},

		isActive (name) {
			if (name === this.selectedCity) {
				return true
			}
			return false
		}
	},
}

// TODO stylus css omg

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.engine-city-search {
	display: flex;
	flex-direction: column;
	width: 250px;
	padding: 10px;
	font-family: 'Roboto', sans-serif;
}

.city-input {
	width: 100%;
	height: 40px;
	padding-left: 5px;

}

.city-search {
	height: 30px;
}

.city-list {
	background-color: white;
	width: 100%;
	height: 300px;
	margin-top: 30px;
	overflow-y: scroll;
}

.city-list-searching {
	background-color: #CCE6FF;
	width: 100%;
	height: 300px;
	margin-top: 30px;
}

.city-list-item {
	height: 40px;
	line-height: 40px;
	font-size: 18px;
	border-bottom: 1px solid gray;
	background-color: #CCE6FF;
	text-align: left;
	padding-left: 10px;
	color: rgb(73, 73, 73);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
}

.active {
	background-color: #9CCFFF;
}

.city-input-together {
	display: flex;
	flex-direction: row;
}

.city-input-hide {
	display: none;
}

.selected-city {
	text-align: left;
}

.my-list {
	max-height: 300px;
	min-height: 300px;
	overflow-y: scroll;
	background-color: white;
	padding: 0px;
	margin-top: 30px;
	cursor: pointer;

}

@media (max-width: 1000px) {
	.engine-city-search {
		display: flex;
		flex-direction: column;
		width: 90%;
		/* padding: 10px; */
		font-family: 'Roboto', sans-serif;
		border-bottom: 1px solid gray;
	}

	.city-input-hide {
		display: block;
		width: 40px;
		height: 38px;
		background-color: #cccccc;
		line-height: 40px;
		font-size: 24px;
		cursor: pointer;
		border-radius: 5px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/engine/citySearch.vue